import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useI18n } from '@modules/i18n/composables';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATES_UNCONFIRMED_PERMISSIONS,
  AFFILIATES_UNCONFIRMED_SEND_EMAIL_MUTATION_KEY,
  AFFILIATES_UNCONFIRMED_SEND_EMAIL_URL,
  TRANSLATION_GROUP_AFFILIATES_UNCONFIRMED,
} from '../constants';

export default function useUnconfirmedAffiliatesSendEmailMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPost } = useRestClient();
  const { getTranslation } = useI18n();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATES_UNCONFIRMED_SEND_EMAIL_MUTATION_KEY],
    mutationFn: (id) => fetchPost<void>(
      AFFILIATES_UNCONFIRMED_SEND_EMAIL_URL,
      {},
      {
        permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
        urlParams: { id },
      },
    ),
    onSuccess() {
      displayPresetToast('success', getTranslation(TRANSLATION_GROUP_AFFILIATES_UNCONFIRMED, 'EMAIL_SENT').value);
    },
  });
}
